import { ApiResponse } from '../../types/api';
import { Complaint } from '../../types/complaint';
import { TriageComplaintDto, SupervisorAssignmentDto } from '../../types/workflow';
import { complaintService } from '../complaint/complaintService';

export class WorkflowService {
  async triageComplaint(dto: TriageComplaintDto): Promise<ApiResponse<Complaint>> {
    let nextStatus = 'Under Review';
    if (dto.action === 'ACCEPT') nextStatus = dto.supervisor_name ? 'Assigned' : 'Under Review';
    if (dto.action === 'REJECT') nextStatus = 'Cancelled';

    const res = await complaintService.getComplaintById(dto.complaint_id);
    if (res.success && res.data) {
      const complaint = res.data;
      complaint.status_name = nextStatus as any;
      if (dto.supervisor_name) complaint.assigned_supervisor_name = dto.supervisor_name;
      if (dto.priority_name) complaint.priority_name = dto.priority_name;
      complaint.assigned_officer_name = 'Officer Rajesh Kumar';
      return { success: true, data: complaint, message: `Complaint ${dto.action}ED successfully` };
    }
    return { success: false, data: null as any, message: 'Complaint not found' };
  }

  async assignSupervisor(dto: SupervisorAssignmentDto): Promise<ApiResponse<Complaint>> {
    const res = await complaintService.getComplaintById(dto.complaint_id);
    if (res.success && res.data) {
      const complaint = res.data;
      complaint.assigned_supervisor_name = dto.supervisor_name;
      complaint.status_name = 'Assigned';
      return { success: true, data: complaint, message: 'Supervisor assigned successfully' };
    }
    return { success: false, data: null as any, message: 'Complaint not found' };
  }
}

export const workflowService = new WorkflowService();
